<template>
   <div class="" uk-grid>
     <div class="uk-width-5-6@m">
        <h4 v-if="!question.isEdit">{{number}}. {{question.title}}</h4>
        <form v-else class="uk-form-stacked">
            <h4>{{number}}. {{question.title}}</h4>
            <div class="uk-margin">
                <label class="uk-form-label">Question</label>
                <div class="uk-form-controls">
                    <input class="uk-input" type="text" v-model="question.title">
                </div>
            </div>
            <div class="uk-margin" v-if="type === 'Energy'">
              <label class="uk-form-label">Reversed</label>
              <div class="uk-form-controls">
                    <input class="uk-checkbox" type="checkbox" v-model="question.reserved">
              </div>
            </div>
            <div class="uk-margin" v-if="type === 'Energy'">
                <div class="uk-form-label">Level</div>
                <div class="uk-form-controls">
                    <label><input class="uk-radio" type="radio" name="radio1" value="1" v-model="question.level"> 1</label>&nbsp;&nbsp;
                    <label><input class="uk-radio" type="radio" name="radio1" value="2" v-model="question.level"> 2</label>&nbsp;&nbsp;
                    <label><input class="uk-radio" type="radio" name="radio1" value="3" v-model="question.level"> 3</label>&nbsp;&nbsp;
                    <label><input class="uk-radio" type="radio" name="radio1" value="4" v-model="question.level"> 4</label>&nbsp;&nbsp;
                    <label><input class="uk-radio" type="radio" name="radio1" value="5" v-model="question.level"> 5</label>&nbsp;&nbsp;
                    <label><input class="uk-radio" type="radio" name="radio1" value="6" v-model="question.level"> 6</label>&nbsp;&nbsp;
                    <label><input class="uk-radio" type="radio" name="radio1" value="7" v-model="question.level"> 7</label>&nbsp;&nbsp;
                </div>
            </div>
            <list-answers v-bind:parent-id="question._id" v-bind:type="type" v-bind:answers="question.answers"></list-answers>
        </form>
      </div>
      <div class="uk-width-1-6@m">
        <ul class="uk-iconnav">
            <li v-if="!question.isEdit"><a href="#" uk-icon="icon: pencil" @click.prevent="question.isEdit = !question.isEdit" uk-tooltip="Edit question"></a></li>
            <li v-if="!question.isEdit"><a href="#" uk-icon="icon: trash" @click.prevent="deleteQuestion()" uk-tooltip="Delete question"></a></li>
            <li v-if="question.isEdit"><a href="#" uk-icon="icon: check" @click.prevent="updateQuestion()" uk-tooltip="Update question"></a></li>
            <li v-if="question.isEdit"><a href="#" uk-icon="icon: close" @click.prevent="question.isEdit = !question.isEdit" uk-tooltip="Close without editing"></a></li>
            <span v-if="message" class="uk-text-small uk-text-light" :class="message.type">{{message.text}}</span>
        </ul>
      </div>
    </div>
</template>

<script>
import QuestionService from '@/services/question.service';
import ListAnswers from '@/components/ListAnswers';
export default {
    name: 'ItemQuestion',
    props: {
      type: String,
      item: Object,
      number: Number
    },
    components: {
      'list-answers': ListAnswers
    },
    data() {
      return {
        message: {}
      }
    },
    created() {
      setInterval(() => {
        this.message = null;
      }, 10000)
    },
    methods: {
      deleteQuestion() {
        // Emit  deleteQuestion parent(list-question)
        this.$emit('delete:question', this.question._id);
      },
      updateQuestion(){
        QuestionService.update(this.question).then(
          res => {
            this.message = {text: res.data.message, type: 'uk-text-success'}
          },
          error => {
            let message = (error.response && error.response.data.message.message) || error.message || error.toString();
            this.message = {text: message, type: 'uk-text-danger'}
          }
        )
      }
    },
    computed: {
      question() {
        return this.item;
      }
    },
}
</script>

<style>

</style>